import { types, Instance } from 'mobx-state-tree';
const { model, number, string, maybe } = types;

export const GeneralStatisticModel = model('GeneralStatisticModel', {
  usedAccounts: string,
  leftAccounts: string,
  freeTier: maybe(string),
  freeTierStatment: maybe(string),
  numberOfEndUsersAuthenticatedMonth: number,
  numberOfEndUsersAuthenticatedYear: number,
  numberOfAuthenticationsMonth: number,
  numberOfAuthenticationsYear: number,
  leftSubscriptionDays: number,
  deviceDetected: number,
  appProvisioned: number,
});

export type IGeneralStatisticModel = Instance<typeof GeneralStatisticModel>;
